import './promotion.scss';

class Promotion {
    constructor ($promotion, id) {
        this.$promotion = $promotion;
        this.timing = parseInt(promotionTiming) * 1000; // eslint-disable-line
        this.$promotionInput = document.querySelector('[id="' + id + '"]');
    }

    initialize () {
        if (this.$promotion) {
            const seen = this.getStatus('promotion');

            if (!seen) {
                this.setStatus('promotion', false);
                this.setTiming();
            }
        }
    }

    setTiming () {
        if (this.$promotionInput) {
            setTimeout(() => {
                this.showPromotion();
            }, this.timing);
        }
    }

    showPromotion () {
        this.setStatus('promotion', true);
        this.$promotionInput.checked = true;
    }

    setStatus (key, seen) {
        const item = {
            seen: seen
        };

        sessionStorage.setItem(key, JSON.stringify(item));
    }

    getStatus (key) {
        const itemStr = sessionStorage.getItem(key);

        if (!itemStr) {
            return false;
        }

        const item = JSON.parse(itemStr);

        if (item.seen === false) {
            return false;
        } else {
            return item.seen;
        }
    }
}

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$promotions = $context.querySelectorAll('[data-promotion="wheel_finder_promo"]');

        if ($$promotions.length > 0) {
            for (let i = 0; i < $$promotions.length; i++) {
                const promotion = new Promotion($$promotions[i], $$promotions[i].getAttribute('data-promotion'));
                promotion.initialize();
            }
        }
    }
});
